import { InteractionRequiredAuthError, PublicClientApplication } from "@azure/msal-browser";

export async function getGraphAccessToken(msalInstance: PublicClientApplication, account: any, errorStr: string = ""): Promise<string> {
  const accessTokenRequest = {
    scopes: ["User.Read"],
    account: account
  };

  try {
    const res = await msalInstance.acquireTokenSilent(accessTokenRequest);
    return res.accessToken;
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      await msalInstance.acquireTokenRedirect(accessTokenRequest);
    } else {
      console.debug(`Error occurs: ${errorStr}`);
    }
    throw error;
  }
}